import React from "react";
import {
  Box, Grid,
  TableBody, TableCell, TableContainer, TableHead, TableRow, Table, Paper
} from '@material-ui/core';
import moment from 'moment';
export default class ComponentToPrint extends React.Component {
  render() {
    const voucherData = this.props.voucherData;
    const factoryData = this.props.factoryData;

    return (
      <Paper elevation={0} style={{ width: '100%', height: '100%' }}>
        <div
          style={{
            fontFamily: 'sans-serif',
            position: 'relative',
            width: '100%',
            height: 'auto',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
          className="record-container"
        >
          <div className="table-responsive row-top-gap" style={{ width: '100%' }}>
            <div style={{ fontSize: "12px" }}>
              <p style={{ textAlign: 'center', paddingBottom: '3px' }}>{factoryData.groupName}</p>
              <p style={{ textAlign: 'center', paddingBottom: '3px' }}>{factoryData.factoryName}</p>
              <p style={{ textAlign: 'center', fontSize: "11px" }}>MAIN CASH PAYMENT VOUCHER</p>
            </div>
            &nbsp;
            <Grid container style={{ fontSize: "12px" }}>
              <Grid container xs={8}>
                <Grid item xs={4}>
                  <div
                    className="col"
                    align="left"
                    style={{ paddingBottom: "4px" }}
                  >
                    <p>Recipient</p>
                  </div>
                  <div
                    className="col"
                    align="left"
                    style={{ paddingBottom: "4px" }}
                  >
                    <p>Payable To</p>
                  </div>
                  <div
                    className="col"
                    align="left"
                    style={{ paddingBottom: "4px" }}
                  >
                    <p>Description</p>
                  </div>
                </Grid>
                <Grid item xs={8}>
                  <div
                    className="col"
                    align="left"
                    style={{ paddingBottom: "4px" }}
                  >
                    <p>{voucherData.customerName + "(" + voucherData.registrationNumber + ")"}</p>
                  </div>
                  <div
                    className="col"
                    align="left"
                    style={{ paddingBottom: "4px" }}
                  >
                    <p>{voucherData.routeManagerName == null ? "-" : voucherData.routeManagerName}</p>
                  </div>
                  <div
                    className="col"
                    align="left"
                    style={{ paddingBottom: "4px", fontSize: "12px" }}
                  >
                    <p>B/L Advance for
                      {voucherData.yearMonth.length !== 0 ? (" " + moment(voucherData.yearMonth[0].applicableMonth).format('MMMM') + " " + moment(voucherData.yearMonth[0].applicableYear).format('YYYY') + " " + voucherData.routeName) : ""}
                      {voucherData.yearMonth.length !== 0 ? (voucherData.yearMonth.length === 2 ? (" / " + (moment(voucherData.yearMonth[1].applicableMonth).format('MMMM'))) : "") : ""}</p>
                  </div>
                </Grid>
              </Grid>
              <Grid container xs={4}>
                <Grid xs={6}>
                  <div
                    className="col"
                    align="left"
                    style={{ paddingBottom: "4px" }}
                  >
                    <p>V : NO</p>
                  </div>
                  <div
                    className="col"
                    align="left"
                    style={{ paddingBottom: "4px" }}
                  >
                    <p>Date</p>
                  </div>
                  <div
                    className="col"
                    align="left"
                    style={{ paddingBottom: "4px" }}
                  >
                    <p>CHQ No</p>
                  </div>
                </Grid>
                <Grid xs={6}>
                  <div
                    className="col"
                    align="left"
                    style={{ paddingBottom: "4px" }}
                  >
                    <p>{(voucherData.voucherDetails).length === 0 ? "" : voucherData.voucherDetails[0].referenceNumber}</p>
                  </div>
                  <div
                    className="col"
                    align="left"
                    style={{ paddingBottom: "4px" }}
                  >
                    <p>{(voucherData.issuingDate).split('T')[0]}</p>
                  </div>
                  <div
                    className="col"
                    align="left"
                    style={{ paddingBottom: "4px" }}
                  >
                    <p>{(voucherData.voucherDetails).length === 0 ? "" : voucherData.voucherDetails[0].voucherNumber}</p>
                  </div>
                </Grid>
              </Grid>
            </Grid>
            <div>&nbsp;</div>
            <Box>
              <TableContainer>
                <Table aria-label="caption table">
                  <TableHead>
                    <TableRow style={{
                      borderBottom: "1px solid black",
                    }}>
                      <TableCell align={'left'}
                        style={{
                          border: "0px solid black",
                          padding: "2px",
                          fontSize: "11px",
                        }}
                      >Acc Code</TableCell>
                      <TableCell align={'left'}
                        style={{
                          border: "0px solid black",
                          padding: "2px",
                          fontSize: "11px",
                        }}
                      >Account Name</TableCell>
                      <TableCell align={'right'}
                        style={{
                          border: "0px solid black",
                          padding: "2px",
                          fontSize: "11px",
                        }}
                      >QTY</TableCell>
                      <TableCell align={'right'}
                        style={{
                          border: "0px solid black",
                          padding: "2px",
                          fontSize: "11px",
                        }}
                      >Rate</TableCell>
                      <TableCell align={'right'}
                        style={{
                          border: "0px solid black",
                          padding: "2px",
                          fontSize: "11px",
                        }}
                      >Dr</TableCell>
                      <TableCell align={'right'}
                        style={{
                          border: "0px solid black",
                          padding: "2px",
                          fontSize: "11px",
                        }}
                      >Cr</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody style={{ borderBottom: '1px solid black' }}>
                    {voucherData.voucherDetails.map((data, index) => (
                      <TableRow key={index} style={{ borderBottom: "1px solid black" }}>
                        <TableCell align="left" style={{ borderBottom: "none", fontSize: '11px', padding: "2px" }}>
                          {data.ledgerAccountCode}
                        </TableCell>
                        <TableCell align="left" style={{ borderBottom: "none", fontSize: '11px', padding: "2px" }}>
                          {data.accountName}
                        </TableCell>
                        <TableCell align="right" style={{ borderBottom: "none", fontSize: '11px', padding: "2px" }}>
                          {0}
                        </TableCell>
                        <TableCell align="right" style={{ borderBottom: "none", fontSize: '11px', padding: "2px" }}>
                          {0}
                        </TableCell>
                        <TableCell align="right" style={{ borderBottom: "none", fontSize: '11px', padding: "2px" }}>
                          {data.debit != 0 ? data.debit.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : ''}
                        </TableCell>
                        <TableCell align="right" style={{ borderBottom: "none", fontSize: '11px', padding: "2px" }}>
                          {data.credit != 0 ? data.credit.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : ''}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                  <TableBody>
                    <TableRow style={{ borderBottom: "1px solid black" }}>
                      <TableCell style={{ fontSize: "11px", padding: "2px", border: 'none' }}></TableCell>
                      <TableCell style={{ fontSize: "11px", padding: "2px", border: 'none' }}></TableCell>
                      <TableCell style={{ fontSize: "11px", padding: "2px", border: 'none' }}></TableCell>
                      <TableCell style={{ fontSize: "11px", padding: "2px", border: 'none' }}></TableCell>
                      <TableCell align="right" style={{ border: "0px", fontSize: "11px", padding: "2px" }}>
                        {voucherData.totalDebit === undefined ? "" : voucherData.totalDebit.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </TableCell>
                      <TableCell align="right" style={{ border: "0px", fontSize: "11px", padding: "2px" }}>
                        {voucherData.totalCredit === undefined ? "" : voucherData.totalCredit.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
            &nbsp;
            &nbsp;
            <br />
            <br />
            <Grid container style={{ fontSize: '12px' }}>
              <Grid item xs={12}>
                <p>{voucherData.preparedUserName == null ? "-" : voucherData.preparedUserName}</p>
              </Grid>
              <Grid item xs={3} align="left">
                <div 
                className="row" 
                align="left"
                >
                  Prepared By
                </div>
              </Grid>
              <Grid item xs={3} align="left">
                <div 
                className="row" 
                align="left"
                >
                  Checked By
                  </div>
              </Grid>
              <Grid item xs={2} align="left">
                <div 
                className="row" 
                align="left"
                >
                  Approved By
                  </div>
              </Grid>
              <Grid item xs={4} align="left">
                <div 
                className="row" 
                align="right"
                >
                  Received by
                  </div>
              </Grid>
            </Grid>
          </div>
        </div>
      </Paper>
    );
  }
}
